import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useParams} from "react-router-dom";
import defaultImage from "../img/default.jpg";
import frameDefault from "../img/thumb/frame-100x60.png";
import Pagination from "react-js-pagination";

export default function ProviderDetail(prop) {
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let memberId = decode.memberId;

    let [data, setData] = React.useState(null);
    let [detail, setDetail] = React.useState(null);

    let [serviceTypeName, setServiceTypeName] = React.useState(null);
    let [serviceAreaName, setServiceAreaName] = React.useState(null);
    let [certificateList, setCertificateList] = React.useState([]);

    React.useEffect(() => {

        (async function() {
            try {
                const resServiceType = await Utils.getCyberServiceType();
                const resServiceArea = await Utils.getCyberServiceArea();

                const resView = await getView();
                setData(resView);

                const resDetail = await getDetail();
                if(resDetail) {
                    if(prop !== null && prop.lang === 'en') {
                        resDetail.title = resDetail.title_en;
                        resDetail.detail = resDetail.detail_en;
                    }
                    setDetail(resDetail);

                    document.title = (prop.lang === 'en' ? 'Cybersecurity Service Provider Information':'ข้อมูลผู้ประกอบการด้านความมั่นคงปลอดภัยไซเบอร์');

                    if(resDetail?.serviceItem.length > 0 && resServiceType.count > 0) {
                        let items = [];
                        for(let rs of resDetail?.serviceItem) {
                            let serviceTypeRow = resServiceType.rows.filter(e => e.id === rs.serviceTypeId)[0];
                            items.push(prop.lang === 'en' ? serviceTypeRow.title_en : serviceTypeRow.title);
                        }
                        setServiceTypeName(items.join(', '));
                    }
                    if(resDetail?.areaItem.length > 0 && resServiceArea.count > 0) {
                        let items = [];
                        for(let rs of resDetail?.areaItem) {
                            let serviceAreaRow = resServiceArea.rows.filter(e => e.id === rs.serviceAreaId)[0];
                            items.push(prop.lang === 'en' ? serviceAreaRow.title_en : serviceAreaRow.title);
                        }
                        setServiceAreaName(items.join(', '));
                    }

                    let certLevelList = [];
                    if(resDetail?.form) {
                        for(let c of resDetail?.form) {
                            if(c.certificate && c.certificate.code && c.certificate.fileCertificate && c.certificateType && c.certificateLevel) {
                                if(prop.lang === 'en') {
                                    certLevelList.push({
                                        code: c.certificate.code,
                                        link: Config.fileUpload.replace('/FileUpload', '') + 'certificate/' + c.certificate?.fileCertificate,
                                        title: c.certificateType.title_en + ' (' + c.certificateLevel.title_en + ')'
                                    });
                                }
                                else {
                                    certLevelList.push({
                                        code: c.certificate.code,
                                        link: Config.fileUpload.replace('/FileUpload', '') + 'certificate/' + c.certificate?.fileCertificate,
                                        title: c.certificateType.title + ' (' + c.certificateLevel.title + ')'
                                    });
                                }
                            }
                        }
                        if(certLevelList.length > 0) {
                            setCertificateList(certLevelList);
                        }
                    }
                }

            } catch (e) {
                //
            }
        })();
    }, []);

    async function getView() {
        const response = await fetch(Config.apiUrl +'/researcherBanner/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getDetail() {
        const response = await fetch(Config.apiUrl +'/cyber/viewDetail', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id:  memberId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner small">
                {
                    data?.image ? <img src={Config.fileUpload + 'researcher_banner/' + data?.image} alt="" /> : ''
                }
                <div className="container">
                    <h1 className="h2 textrow">
                        <span data-aos="fade-up">{prop.lang === 'en' ? 'Cyber Security Service Provider Information':'ข้อมูลผู้ประกอบการด้านความมั่นคงปลอดภัยไซเบอร์'}</span>
                    </h1>
                    <p data-aos="fade-in"><NavLink to="/">{prop.lang === 'en' ? 'Home':'หน้าแรก'}</NavLink> / <NavLink to={ (prop.lang === 'en' ? '/en':'') + "/cyber"}>{prop.lang === 'en' ? 'Cybersecurity Service Provider Information':'ข้อมูลผู้ประกอบการด้านความมั่นคงปลอดภัยไซเบอร์'}</NavLink> </p>
                </div>
            </div>

            <div className="section">
                <div className="container has-sidebar" data-aos="fade-in">
                    <div className="sidebar">
                        <div className="row g-lg-4 g-3">
                            <div className="col-12">
                                <div className="form-group">
                                    <p className="p-2" style={{backgroundColor:'#f1f1f1'}}><img src={detail?.businessLogo !== null ? Config.fileUpload + 'memberBusinessLogo/' + detail?.businessLogo : defaultImage} className="img-fluid" /></p>
                                    <h6>{detail?.businessName}</h6>
                                    <ul className="list-group list-group-flush">
                                        <li className="list-group-item"><strong>{prop.lang === 'en' ? 'Service Area':'พื้นที่ให้บริการ'}</strong> : {serviceAreaName}</li>
                                        <li className="list-group-item"><strong>{prop.lang === 'en' ? 'Service Type':'ประเภทบริการ'}</strong> : {serviceTypeName}</li>
                                        <li className="list-group-item">
                                            <strong>{prop.lang === 'en' ? 'Certified Services':'บริการที่ได้รับการรับรอง'}</strong> :
                                            {
                                                certificateList.length > 0 ?
                                                    certificateList.map((row, index) => {
                                                        return (
                                                            <div key={index} className="mb-1"><NavLink to={row.link} target="_blank" className="download-link">{row.code}</NavLink> {row.title}</div>
                                                        )
                                                    }): '-'
                                            }
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            {
                                detail?.businessEmail ? <div className="col-12">
                                    <a href={'mailto:' + detail?.businessEmail} className="btn w-100">{prop.lang === 'en' ? 'Contact Email':'ติดต่อผู้ให้บริการ'}</a>
                                </div> : ''
                            }
                            {
                                detail?.businessWebsite ? <div className="col-12">
                                    <a href={detail?.businessWebsite} className="btn w-100" target="_blank">{prop.lang === 'en' ? 'Enter Website':'เข้าชมเว็บไซต์'}</a>
                                </div> : ''
                            }
                        </div>
                    </div>
                    <div className="content">
                        <div dangerouslySetInnerHTML={{__html: detail?.businessInfo}}></div>

                        {
                            detail?.productItem !== null &&  detail?.productItem.length > 0 ?
                                <>
                                    <h3 className="mt-3 mb-1">{prop.lang === 'en' ? 'Products & Services':'สินค้าและบริการ'}</h3>
                                    <div className="row card-news-lists">
                                        {
                                            detail.productItem.map((row, index) => {
                                                return (
                                                    <div key={index} className="col-lg-3 col-md-4 col-sm-6">
                                                        <div className="card-news bg-none" data-aos="fade-in">
                                                            <NavLink to={row.link} target="_blank" className="card-link"></NavLink>
                                                            <div className="card-photo">
                                                                <div className="photo"
                                                                     style={{backgroundImage: 'url("' + (row?.file !== null ? Config.fileUpload + 'cyber_product/' + row?.file : defaultImage) + '")'}}>
                                                                    <img src={frameDefault} alt="" />
                                                                </div>
                                                            </div>
                                                            <div className="card-body">
                                                                <h3>{row?.title}</h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </> : ''

                        }
                    </div>
                </div>
            </div>
        </>
    );
} 